import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import {Doughnut} from 'react-chartjs'
import config from '../../config'
import format from '../../helpers/format'
// import { LinkIcon } from '../'
import Styles from './FundIssueCoverageBox.css'

/*
 * FundOssueCoverageBox
 *
 * @param <string> issueId
 * @param <number> count
 * @param <number> percentRated
 *
 *
 */
@CSSModules(Styles, {allowMultiple:true})
export default class FundIssueCoverageBox extends Component {
  static propTypes = {
    issueId: PropTypes.string.isRequired,
    count: PropTypes.string,
    percentRated: PropTypes.string
  }
  constructor(props){
    super(props)

    const emptyChartData = [
      {
        value: 1,
        color: 'grey'
      }
    ]

    const populatedChartData = [
      {
        value: this.props.percentRated,
        color: '#352b56'
      },
      {
        value: 1-this.props.percentRated,
        color: 'grey'
      }
    ]

    const chartData = parseFloat(props.count) === config.sjfNullSentinel ?
      emptyChartData :
      populatedChartData

    this.state = {
      chartData,
      chartOptions: {
        animation: false,
        segmentStrokeWidth: 0,
        percentageInnerCutout: 0,
        showTooltips: false
      }
    }
  }
  //
  render() {
    if (!this.props.issueId) return null
    //
    return <div styleName='ficb-wrap flex-center'>
      <div styleName='flex-1  mw'>
        <span><b>FUND COVERAGE</b></span>
      </div>
      <div styleName='flex-1'>
        <div styleName='flex-apart'>
          <div>
            <div styleName='flex-center'>
              <span styleName='flex-1 fw'><b># of holdings</b></span>
              <span styleName='flex-1'>
                { /* CHECK IF UNSCORED (ZERO COVERAGE) */
                  parseFloat(this.props.count) === config.sjfNullSentinel ?
                    0 :
                    format.number(this.props.count)
                }
              </span>
            </div>
            <div styleName='flex-center'>
              <span styleName='flex-1 fw'><b>% of assets</b></span>
              <span styleName='flex-1'>
                { /* CHECK IF UNSCORED (ZERO COVERAGE) */
                  parseFloat(this.props.percentRated) === config.sjfNullSentinel ?
                    '0%' :
                    format.perc(this.props.percentRated)
                }
              </span>
            </div>
          </div>
          <Doughnut
            data={this.state.chartData}
            options={this.state.chartOptions}
            width={50}
            height={50}
          />
        </div>
      </div>
    </div>
  }
}
